export default __webpack_public_path__ + "static/cgr-logo-desktop-2057ddcca30f295a4895dc9970915ecd.svg";